import { isNumber, isBoolean } from 'lodash';
import Icon, { textIcon, globeIcon } from '../../components/icons';
import { INTERNAL_SURVEY_TYPE } from '../../constants';
import { getLanguageForKey } from '../../utils';
import { publicAssetsPrefix } from '../../../../../configuration';

const clock = Icon({ type: 'clock', size: 15 });
const clockWhite = Icon({ type: 'clock', color: 'white', size: 15 });
const hotIconLarge = Icon({ type: 'hot', color: 'white', size: 57 });
const hotIcon = Icon({ type: 'hot', color: '#FB3B71', rounded: true });
const star = Icon({ type: 'star', color: '#8F98A9', size: 14 });
const starDisabled = Icon({ type: 'star', color: '#f39eb6', size: 14 });
const starChecked = Icon({ type: 'star', color: '#F8D94B', size: 14 });
const internalSurveyIcon = Icon({
  type: 'internal',
  color: '#5c6776',
  rounded: true,
});

const shouldShowPointsValue = (type, pointsValue) =>
  type !== INTERNAL_SURVEY_TYPE || (isNumber(pointsValue) && pointsValue > 0);

const getPointsTextHotSurvey = (
  type,
  pointsValue,
  rewardOfferPreviousValue,
  pointsName,
) => {
  if (shouldShowPointsValue(type, pointsValue) && !rewardOfferPreviousValue) {
    return `
      <h1 class="text-xxl margin-reset line-height-reset">${pointsValue}</h1>
      <p data-testid="survey-reward-currency">${pointsName}</p>
    `;
  }

  if (
    shouldShowPointsValue(type, pointsValue) &&
    shouldShowPointsValue(type, rewardOfferPreviousValue)
  ) {
    return `
      <div>
        <p class="margin-reset" style="font-size: 14px; text-decoration:line-through;">${rewardOfferPreviousValue}</p>
        <h1 class="text-xxl margin-reset line-height-reset">${pointsValue}</h1>
        <p data-testid="survey-reward-currency">${pointsName}</p>
      </div>
    `;
  }

  return '';
};

const hotSurveyTemplate = ({
  id,
  type,
  pointsValue,
  rewardOfferPreviousValue,
  pointsName,
  loi,
  ratingCount,
  rating,
  // showLang,
  // lang,
  surveyProvider,
  surveyProviderImage,
  getText,
  index,
  listLength,
  noCheck,
}) => `
  <article
    class="card-v2 js-survey-card hot"
    data-id="${id}"
    data-survey-index="${index}"
    data-surveys-list-length="${listLength}"
    ${isBoolean(noCheck) ? `data-survey-no-check="${noCheck}"` : ''}
    data-testid="survey-card"
  >
    <section class="card-v2-body flex flex-align-items--${
      shouldShowPointsValue(type, pointsValue) ? 'center' : 'end'
    }">
      <div class="flex-1">
        ${getPointsTextHotSurvey(
          type,
          pointsValue,
          rewardOfferPreviousValue,
          pointsName,
        )}
        <p class="font-bold margin-reset">${clockWhite} ${loi} ${getText(
  'offerwall.surveyCard.minutes',
)}</p>
        <p class="margin-reset text-grey">
          ${rating}
          <span class="text-sm">(${ratingCount})</span>
        </p>
      </div>
      <div class="flex flex-column text-align-center padding-md-horizontal">
        <div class="margin-sm-top">${hotIconLarge}</div>
        <span class="margin-xs-top">${getText(
          'offerwall.surveyCard.top',
        )}</span>
      </div>
    </section>
    <section class="card-v2-footer">
      <div class="flex flex-align-items--center">
        <span style="line-height: 1;" class="text-sm flex-1 flex-no-wrap">${getText(
          'surveyBy',
        )}:</span>
        <div class="margin-xs-left">
          <img style="max-height: 15px; max-width:100%; display: block;" src="${surveyProviderImage}" alt="${surveyProvider}" />
        </div>
      </div>
    </section>
  </article>
`;

const surveyTemplate = ({
  id,
  isInternalSurvey,
  pointsValue,
  pointsName,
  rewardOfferPreviousValue,
  loi,
  ratingCount,
  rating,
  tags,
  showLang,
  lang,
  surveyProvider,
  surveyProviderImage,
  getText,
  index,
  listLength,
  noCheck,
}) => {
  let pointsTemplate = `
    <h1 class="text-xxl margin-reset line-height-reset">
      ${pointsValue > 0 ? pointsValue : '&nbsp;'}
    </h1>
  `;
  if (rewardOfferPreviousValue && rewardOfferPreviousValue > 0) {
    pointsTemplate = `
      <div>
        <p class="margin-reset" style="text-decoration:line-through; color: #fb3b71;">
          ${rewardOfferPreviousValue}
        </p>
        <h1 class="text-xxl margin-reset line-height-reset">
          ${pointsValue > 0 ? pointsValue : '&nbsp;'}
        </h1>
      </div>
    `;
  }
  return `
    <article
      class="card-v2 js-survey-card"
      data-id="${id}"
      data-survey-index="${index}"
      data-surveys-list-length="${listLength}"
      ${isBoolean(noCheck) ? `data-survey-no-check="${noCheck}"` : ''}
      data-testid="survey-card"
    >
      <section class="card-v2-body">
        <header class="flex">
          <div class="flex-1">
            ${pointsTemplate}
            <p data-testid="survey-reward-currency">
              ${pointsValue > 0 ? pointsName : '&nbsp;'}
            </p>
          </div>
          <ul class="text-align-right reset-ul">
            ${
              tags.indexOf('hot') >= 0
                ? `
              <li class="inline-block v-middle margin-xxs-btm">
                ${hotIcon}
              </li>`
                : ''
            }
            ${
              tags.indexOf('new') >= 0
                ? `
              <li class="inline-block v-middle margin-xxs-btm">
                ${textIcon(getText('offerwall.surveyCard.new'))}
              </li>`
                : ''
            }
            ${
              isInternalSurvey
                ? `
              <li class="inline-block v-middle margin-xxs-btm">
                ${internalSurveyIcon}
              </li>`
                : ''
            }
            ${
              showLang
                ? `
              <li class="block v-middle margin-xxs-btm">
                <div class="survey-lang-icon">
                  <span>${globeIcon}</span>
                  <span>${getLanguageForKey(lang)}</span>
                </div>
              `
                : ''
            }
            </li>
          </ul>
        </header>
        <p class="font-bold margin-reset">${clock} ${loi} ${getText(
    'offerwall.surveyCard.minutes',
  )}</p>
        <p class="margin-reset text-grey">
          ${rating}
          <span class="text-sm">(${ratingCount})</span>
        </p>
      </section>
      <footer class="card-v2-footer">
        <div class="divider margin-md-btm"></div>
        <div class="flex flex-align-items--center">
          <span style="line-height: 1; max-width: 60%;" class="text-sm flex-1 flex-no-wrap">${getText(
            'surveyBy',
          )}:</span>
          <div class="margin-xs-left">
            <img style="max-height: 15px; max-width:100%; display: block;" src="${surveyProviderImage}" alt="${surveyProvider}" />
          </div>
        </div>
      </footer>
    </article>
  `;
};

class SurveyCard {
  constructor(props) {
    this.props = {
      id: props.id,
      type: props.type,
      superHot: props.superHot,
      pointsValue: props.pointsValue,
      pointsName: props.pointsName,
      loi: props.loi,
      ratingCount: props.ratingCount,
      rating: props.rating,
      tags: props.tags,
      lang: props.lang,
      surveyProvider: props.surveyProvider,
      rewardOfferPreviousValue: props.reward_offer_previous_value,
      index: props.index,
      listLength: props.listLength,
      noCheck: props.no_check,
    };
  }

  getRating(isSuperHot) {
    let rating = [star, star, star, star, star];
    if (isSuperHot) {
      rating = [
        starDisabled,
        starDisabled,
        starDisabled,
        starDisabled,
        starDisabled,
      ];
    }
    for (let i = 0; i < this.props.rating; i += 1) {
      rating[i] = starChecked;
    }
    return rating.join('');
  }

  render() {
    const { superHot, surveyProvider, lang, type } = this.props;
    let surveyProviderImage = `${publicAssetsPrefix}/img/${surveyProvider
      .toLowerCase()
      .replace(/\s/g, '')}.png`;
    const isInternalSurvey = type === INTERNAL_SURVEY_TYPE;
    if (isInternalSurvey && Pollfish.helper.json.theme_logo) {
      surveyProviderImage = Pollfish.helper.json.theme_logo;
    }
    const showLang =
      lang && Pollfish.helper.json.user_lang.toLowerCase() !== lang;

    const surveyProps = {
      ...this.props,
      showLang,
      rating: this.getRating(superHot),
      surveyProviderImage,
      isInternalSurvey,
      getText: Pollfish.ui.getText,
    };
    return superHot
      ? hotSurveyTemplate(surveyProps)
      : surveyTemplate(surveyProps);
  }
}

export default SurveyCard;
